import { render } from "./ProductAggregatedTable.vue?vue&type=template&id=3a01c9c4&scoped=true&ts=true"
import script from "./ProductAggregatedTable.vue?vue&type=script&lang=ts"
export * from "./ProductAggregatedTable.vue?vue&type=script&lang=ts"

import "./ProductAggregatedTable.vue?vue&type=style&index=0&id=3a01c9c4&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a01c9c4"]])

export default __exports__